import React, { useState, useEffect } from 'react';
import api from '../api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Checkbox } from './ui/checkbox';
import { Plus, X } from '@phosphor-icons/react';

const SERVICES = {
  'Manutenção Preventiva': [
    'Limpeza de eletrodutos',
    'Limpeza de lâmpadas e luminárias',
    'Limpeza de painel elétrico',
    'Limpeza de perfilados e eletrocalhas',
    'Limpeza de refletores',
    'Limpeza de ventiladores e ar condicionado',
    'Reaperto de contatos',
    'Revisão e isolação de emendas de cabos'
  ],
  'Reforma': [
    'Extensão de tomada',
    'Troca de lâmpada fluorescente por LED'
  ],
  'Manutenção Corretiva': [
    'Troca de bóias elétricas',
    'Troca de botões e sinaleiros',
    'Troca de cabos e terminais',
    'Troca de capacitores',
    'Troca de chave fim de curso',
    'Troca de contatores',
    'Troca de disjuntor',
    'Troca de fusíveis',
    'Troca de lâmpada LED',
    'Troca de plug para padrão novo',
    'Troca de resistência de chuveiro',
    'Troca de sensores',
    'Troca de soquete e fiação luminária',
    'Troca de tomada 20A ampéres',
    'Troca de tomada elétrica em curto',
    'Troca de transformador e reator'
  ],
  'Montagem': [
    'Montagem de canaletas sistema X',
    'Montagem de eletrodutos',
    'Montagem de perfilados e eletrocalhas',
    'Montagem de quadro de disjuntores',
    'Montagem de tubulações galvanizadas',
    'Montagem e desmontagem de equipamentos elétricos'
  ],
  'Instalação': [
    'Instalação de aquecedor elétrico',
    'Instalação de cabo de rede Ethernet',
    'Instalação de chuveiro elétrico',
    'Instalação de compressores',
    'Instalação de iluminação de emergência',
    'Instalação de luminárias',
    'Instalação de lustre',
    'Instalação de máquina CNC',
    'Instalação de máquina convencional',
    'Instalação de máquina de lavar',
    'Instalação de máquina lava e seca',
    'Instalação de micro-ondas',
    'Instalação de motores e bombas',
    'Instalação de pendente',
    'Instalação de pressurizador para chuveiro',
    'Instalação de purificador de água',
    'Instalação de sensor de presença',
    'Instalação de spot',
    'Instalação de tomada 20A ampéres',
    'Instalação de tomada trifásica',
    'Instalação de tomadas',
    'Instalação de TV',
    'Instalação de ventilador de parede',
    'Instalação de ventilador de teto'
  ]
};

const CreateReportForm = ({ onSuccess }) => {
  const [clients, setClients] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [workers, setWorkers] = useState([{ worker_id: '', worker_name: '', worker_type: 'tecnico', start_time: '', end_time: '', hours_worked: 0 }]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [clientsRes, collaboratorsRes] = await Promise.all([
        api.get('/clients'),
        api.get('/collaborators')
      ]);
      setClients(clientsRes.data);
      setCollaborators(collaboratorsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const addWorker = () => {
    setWorkers([...workers, { worker_id: '', worker_name: '', worker_type: 'tecnico', start_time: '', end_time: '', hours_worked: 0 }]);
  };

  const removeWorker = (index) => {
    setWorkers(workers.filter((_, i) => i !== index));
  };

  const updateWorker = (index, field, value) => {
    const newWorkers = [...workers];
    newWorkers[index][field] = value;
    
    if (field === 'worker_id') {
      const collab = collaborators.find(c => c.id === value);
      if (collab) {
        newWorkers[index].worker_name = collab.name;
        newWorkers[index].worker_type = collab.role_type;
      }
    }
    
    if (field === 'start_time' || field === 'end_time') {
      if (newWorkers[index].start_time && newWorkers[index].end_time) {
        const start = new Date(`2000-01-01T${newWorkers[index].start_time}`);
        const end = new Date(`2000-01-01T${newWorkers[index].end_time}`);
        const hours = (end - start) / (1000 * 60 * 60);
        newWorkers[index].hours_worked = hours > 0 ? hours : 0;
      }
    }
    
    setWorkers(newWorkers);
  };

  const toggleService = (category, service) => {
    const serviceObj = { category, service };
    const exists = selectedServices.find(s => s.category === category && s.service === service);
    
    if (exists) {
      setSelectedServices(selectedServices.filter(s => !(s.category === category && s.service === service)));
    } else {
      setSelectedServices([...selectedServices, serviceObj]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedClient) {
      alert('Selecione um cliente');
      return;
    }
    
    if (workers.some(w => !w.worker_id || !w.start_time || !w.end_time)) {
      alert('Preencha todos os dados dos colaboradores');
      return;
    }
    
    if (selectedServices.length === 0) {
      alert('Selecione pelo menos um serviço');
      return;
    }
    
    try {
      await api.post('/reports', {
        client_id: selectedClient,
        date,
        workers,
        services: selectedServices,
        notes
      });
      
      // Reset form
      setSelectedClient('');
      setDate(new Date().toISOString().split('T')[0]);
      setWorkers([{ worker_id: '', worker_name: '', worker_type: 'tecnico', start_time: '', end_time: '', hours_worked: 0 }]);
      setSelectedServices([]);
      setNotes('');
      
      alert('Relatório criado com sucesso!');
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error creating report:', error);
      alert('Erro ao criar relatório: ' + (error.response?.data?.detail || error.message));
    }
  };

  return (
    <div className="bg-[#121212] border border-[#27272A] rounded-sm p-6">
      <h3 className="text-2xl font-bold text-white mb-6" style={{ fontFamily: 'Barlow Condensed' }}>
        Novo Relatório de Serviço
      </h3>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Client and Date */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Cliente</Label>
            <Select value={selectedClient} onValueChange={setSelectedClient}>
              <SelectTrigger className="bg-[#050505] border-[#27272A] text-white" data-testid="client-select">
                <SelectValue placeholder="Selecione o cliente" />
              </SelectTrigger>
              <SelectContent className="bg-[#121212] border-[#27272A] text-white">
                {clients.map(client => (
                  <SelectItem key={client.id} value={client.id}>
                    {client.name} ({client.code})
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <Label>Data do Atendimento</Label>
            <Input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="bg-[#050505] border-[#27272A] text-white"
              required
              data-testid="date-input"
            />
          </div>
        </div>

        {/* Workers */}
        <div>
          <div className="flex justify-between items-center mb-3">
            <Label>Colaboradores</Label>
            <Button type="button" onClick={addWorker} className="bg-[#1E1E1E] text-white hover:bg-[#27272A]" size="sm" data-testid="add-worker-button">
              <Plus size={16} className="mr-1" />
              Adicionar
            </Button>
          </div>
          
          {workers.map((worker, index) => (
            <div key={index} className="mb-4 p-4 bg-[#050505] border border-[#27272A] rounded-sm">
              <div className="flex justify-between items-center mb-3">
                <div className="text-zinc-400 text-sm">Colaborador #{index + 1}</div>
                {workers.length > 1 && (
                  <button type="button" onClick={() => removeWorker(index)} className="text-red-500 hover:text-red-400">
                    <X size={16} />
                  </button>
                )}
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                <div>
                  <Label className="text-xs">Nome</Label>
                  <Select value={worker.worker_id} onValueChange={(value) => updateWorker(index, 'worker_id', value)}>
                    <SelectTrigger className="bg-[#121212] border-[#27272A] text-white h-9" data-testid={`worker-select-${index}`}>
                      <SelectValue placeholder="Selecione" />
                    </SelectTrigger>
                    <SelectContent className="bg-[#121212] border-[#27272A] text-white">
                      {collaborators.map(collab => (
                        <SelectItem key={collab.id} value={collab.id}>
                          {collab.name} ({collab.role_type})
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label className="text-xs">Horário Início</Label>
                  <Input
                    type="time"
                    value={worker.start_time}
                    onChange={(e) => updateWorker(index, 'start_time', e.target.value)}
                    className="bg-[#121212] border-[#27272A] text-white h-9"
                    required
                    data-testid={`start-time-${index}`}
                  />
                </div>
                
                <div>
                  <Label className="text-xs">Horário Término</Label>
                  <Input
                    type="time"
                    value={worker.end_time}
                    onChange={(e) => updateWorker(index, 'end_time', e.target.value)}
                    className="bg-[#121212] border-[#27272A] text-white h-9"
                    required
                    data-testid={`end-time-${index}`}
                  />
                </div>
                
                <div>
                  <Label className="text-xs">Horas Trabalhadas</Label>
                  <div className="h-9 flex items-center px-3 bg-[#121212] border border-[#27272A] rounded-sm text-[#FFB800] font-bold">
                    {worker.hours_worked.toFixed(1)}h
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Services */}
        <div>
          <Label className="mb-3 block">Serviços Executados</Label>
          <div className="space-y-4 max-h-96 overflow-y-auto">
            {Object.entries(SERVICES).map(([category, services]) => (
              <div key={category} className="bg-[#050505] border border-[#27272A] rounded-sm p-4">
                <h4 className="text-[#FFB800] font-semibold mb-3" style={{ fontFamily: 'Barlow Condensed' }}>
                  {category}
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {services.map(service => (
                    <div key={service} className="flex items-center space-x-2">
                      <Checkbox
                        id={`${category}-${service}`}
                        checked={selectedServices.some(s => s.category === category && s.service === service)}
                        onCheckedChange={() => toggleService(category, service)}
                        className="border-[#27272A] data-[state=checked]:bg-[#FFB800] data-[state=checked]:border-[#FFB800]"
                      />
                      <label htmlFor={`${category}-${service}`} className="text-sm text-zinc-400 cursor-pointer">
                        {service}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Notes */}
        <div>
          <Label>Observações (opcional)</Label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="w-full px-4 py-2 bg-[#050505] border border-[#27272A] rounded-sm text-white focus:border-[#FFB800] focus:ring-1 focus:ring-[#FFB800] outline-none min-h-24"
            data-testid="notes-textarea"
          />
        </div>

        <Button type="submit" className="w-full bg-[#FFB800] text-black hover:bg-[#E6A600] py-6 text-lg font-semibold" data-testid="submit-report-button">
          Criar Relatório
        </Button>
      </form>
    </div>
  );
};

export default CreateReportForm;
